import React from "react";
import { Grid } from "@mui/material";
import SiteCard from "./SiteCard";
import { SPACING } from "../../theme/constants";

/**
 * Grid of site cards
 */
const SitesGrid = ({
  sites,
  onMenuOpen,
  onManage,
  onVisit,
  onRestore,
  restoreLoading,
}) => {
  return (
    <Grid container spacing={SPACING.lg}>
      {sites.map((site) => (
        <Grid
          key={site.id}
          size={{ xs: 12, md: 6, lg: 4 }}
          sx={{ display: "flex" }}
        >
          <SiteCard
            site={site}
            onMenuOpen={onMenuOpen}
            onManage={onManage}
            onVisit={onVisit}
            onRestore={onRestore}
            restoreLoading={restoreLoading}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default SitesGrid;
